module.exports = __webpack_public_path__ + "static/img/advantages-2.2d481887.png";